function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  let selector = document;
  if (evt.currentTarget.closest(".desktop-product-tabs")) {
    selector = evt.currentTarget.closest(".desktop-product-tabs");
  }
  if (evt.currentTarget.closest(".product-text")) {
    selector = evt.currentTarget.closest(".product-text");
  }
  tabcontent = selector.querySelectorAll(".tab-content:not(active)");
  tabcontent.forEach((tab) => {
    tab.style.display = "none";
  });

  tablinks = selector.querySelectorAll(".tab-link");
  tablinks.forEach((tab) => {
    if (evt.currentTarget === tab) return;
    tab.classList.remove("active");
  });

  const tab = selector.querySelector(`#${tabName}`);
  console.log(tab);
  tab.style.display = tab.style.display == "block" ? "none" : "block";
  if (evt.currentTarget.classList.contains("cta-hay-button")) {
    document
      .getElementById("prices-and-options-tab-btn")
      .classList.toggle("active");
    if (
      !document
        .getElementById("prices-and-options-tab-btn")
        .classList.contains("active")
    ) {
      tab.style.display = "none";
    }
  } else {
    evt.currentTarget.classList.toggle("active");
    if (!evt.currentTarget.classList.contains("active")) {
      tab.style.display = "none";
    }
  }
}

// Initialize default active tab
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("prices-and-options")) {
    document.getElementById("prices-and-options").style.display = "block";
  }
  setTimeout(() => {
    let selector = document;
    if (window.screen.availWidth < 768) {
      selector = document.querySelector(".product-text");
    }
    // selector.querySelector("#details").style.display = "block";
    // selector.querySelector("#details").classList.add("active");
  }, 100);
});
